module.exports = __webpack_public_path__ + "img/logo-mini-old.148dbc24.png";